export default __webpack_public_path__ + "static/media/nbb.9b78c868.png";